
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { Descriptions } from "~/operations/messages";
import ComparisonNationStateCountyChart from "./ComparisonNationStateCountyChart.vue";
import ComparsionChart from "./ComparsionChart.vue";

interface OilPriceHistory {
  reletadUnits: string;
  labels: string[];
  sateOilPriceData: number[];
  nationalOiPriceData: number[];
  countyOiPriceData?: number[];
}

@Component({
  components: {
    ComparsionChart,
    ComparisonNationStateCountyChart,
  },
})
export default class DistrictUnifiedPriceChart extends Vue {
  @Prop({ required: true }) statesOilPriceHistory!: OilPriceHistory;
  @Prop({ required: true }) showStateCityChart!: boolean;
  @Prop({ required: true }) stateName!: string;
  @Prop({ required: true }) districtName!: string;

  Descriptions = Descriptions;

  get chartComponent(): string {
    return this.showStateCityChart
      ? "ComparsionChart"
      : "ComparisonNationStateCountyChart";
  }

  get chartComponentProps() {
    const baseProps = {
      mainChartDataSeries: this.statesOilPriceHistory.sateOilPriceData,
      comparsionChartDataSeries: this.statesOilPriceHistory.nationalOiPriceData,
      comparsionChartDataLabel: "Bundesrepublik",
    };

    if (this.showStateCityChart) {
      return {
        ...baseProps,
        mainChartDataLabel: this.stateName,
      };
    }

    return {
      stateChartDataLabel: this.stateName,
      stateChartSeries: this.statesOilPriceHistory.sateOilPriceData,
      nationChartDataSeries: this.statesOilPriceHistory.nationalOiPriceData,
      countyChartSeries: this.statesOilPriceHistory.countyOiPriceData,
      nationChartDataLabel: "Bundesrepublik",
      countyChartDataLabel: this.districtName,
    };
  }
}
